//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCredits', {
//        templateUrl: 'views/components/views/orderLineCredits/orderLineCredits.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'orderLineCreditsService', 'ttGridFactory', 'rememberService', function ($stateParams, stateService, utilityService, orderLineCreditsService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            let variableNames = {
//                orderlinecredits_selection_id: ''
//            };

//            vm.model = {
//                gridReady: false,
//                setting: {},
//                selectListSelectionIds: []
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await orderLineCreditsService.getOrderLineCredits({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            async function loadSelectionIds() {
//                vm.model.selectListSelectionIds = await orderLineCreditsService.listSelectionIds();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: vm.model.setting
//                    };

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'orderlinecredits_selection_id':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'orderlinecredits_selection_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.orderlinecredits_selection_id) !== true) return;

//                        vm.model.setting.orderlinecredits_selection_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.orderlinecredits_selection_id, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('orderlinecredits_selection_id')
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });

//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
                
//                return Promise.all([
//                    loadSelectionIds()
//                ]).then(() => {
//                    loadGrid();
//                    Promise.resolve();
//                });
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
